module.exports = __webpack_public_path__ + "static/media/item_2_9_comp.ff052cba.png";